<template>
	<el-dialog title="接收" :visible.sync="visible" :before-close='addCageClose' width="1000px" :close-on-click-modal="false" id="addPetView">
		<div class="shopView">
			<div class="roomView">
				<div class="roomName" v-if="shopId == '5e9412e0b2bfbc089daerr12'">金水区店笼子状态展示</div>
				<div class="roomName" v-if="shopId == '5e9412e0b2bfbc089daerr14'">指挥中心笼子状态展示</div>
				<div class="roomName" v-if="shopId == '5e9412e0b2bfbc089daerr16'">拓展部笼子状态展示</div>
				<div class="roomName" v-if="shopId == '5e9412e0b2bfbc089daerr17'">线上旗舰店笼子状态展示</div>
				<div :class="item.room_id == roomId?'roomActive':'room'" v-for="(item, index) in roomList" :key="index" @click="handleRoomClick(item)">{{item.room_name}}</div>
			</div>
			<div class="cageView">
				<div class="cage" v-for="(item,index) in cageList" :key="index">
					<template v-if="item.room_id != ''">
						<div class="cageTitle">{{item.room_name}} (猫: {{item.cat?item.cat:"0"}}只, 犬: {{item.dog?item.dog:'0'}}只)</div>
						<div class="cageItem" v-for="(cageItem,cageIndex) in item.cage_info" :key="cageIndex">
							<div>{{cageItem.cage_name}}</div>
							<div class="petNum" v-if="cageItem.pet_list.length == 0">空</div>
							<template v-else>
								<div class="petNum">
									<span v-if="cageItem.dogCount">犬:{{cageItem.dogCount}}只</span>
									<span v-if="cageItem.catCount">猫:{{cageItem.catCount}}只</span>
								</div>
							</template>
						</div>
					</template>
				</div>
			</div>
		</div>
		<el-row style="margin-top: 10px;">
			<el-col>
				<el-input v-if="eprom_no == ''" placeholder="请输入芯片编号" v-model="chin_no" clearable style="width: 200px;margin-right: 20px;"></el-input>
				<el-cascader :options="intRoom" :props="{ multiple: true, label: 'name',children: 'cages',value: 'id'}" clearable placeholder="请选择笼子" v-model="siteValue"></el-cascader>
			</el-col>
		</el-row>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleReceiveClick">接收</el-button>
		</div>
	</el-dialog>
</template>
<script>
	import {
		cage,
		getShopRoom,
		petsReceive
	} from "@/api/purchaseApi.js"
	export default {
		props: {
			addCageState: { //显示状态
				default: false
			},
			receiveId:{  //转移记录ID
				default: ''
			},
			shopId:{
				default: ''
			},
			eprom_no:{  //芯片编号
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				allList:[],
				cageList:[],  //当前房间笼子列表
				roomList:[],  //房间列表
				roomId:'',  //房间id
				intRoom:[],  //初始化房间
				siteValue:[], //位置数据
				chin_no:'',  //芯片编号
			};
		},
		mounted() {
			this.eprom_no == ''?this.chin_no = '':this.chin_no = this.eprom_no;
			this.getPetsByShopList();
			this.getIntRoom();
			console.log(this.receiveId)
		},
		methods: {
			//初始化笼子
			getIntRoom(){
				let params = {
					shopId:this.shopId
				}
				getShopRoom(params).then((res)=>{
					if(res.code == 0){
						console.log('初始化',res)
						this.intRoom = res.data;
					}
				})
			},
			//切换房间
			handleRoomClick(item){
				// console.log(item)
				this.roomId = item.room_id;
				this.cageId = '';
				if(item.room_id == ''){
					this.cageList = this.roomList
				}else{
					let arr = [];
					arr[0] = item
					this.cageList = arr;
				}
			},
			//获取门店下当前笼子状态
			getPetsByShopList(){
				let pamars = {
					date:this.getStartEndData(new Date()).startStr,
					shopId:this.shopId
				}
				cage(pamars).then((res)=>{
					console.log('门店',res)
					if(res.code == 0){
						if(res.data.length == 0){
							this.roomList = res.data;
							this.cageList = res.data;
							this.allDogNum = 0;
							this.allCatNum = 0;
							return
						}
						res.data.unshift({
							room_id:'',
							room_name:'全部',
							cage_info:res.data
						})
						this.roomList = res.data;
						this.cageList = res.data;
						for(let i = 0; i<res.data.length;i++){
							if(res.data[i].room_id != ''){
								for(let j = 0;j<res.data[i].cage_info.length;j++){
									let catCount = 0;
									let dogCount = 0;
									for(let k = 0;k<res.data[i].cage_info[j].pet_list.length;k++){
										//循环获取数量
										if(res.data[i].cage_info[j].pet_list[k].pet_type.value == '1'){
											catCount = (catCount + 1);
											res.data[i].cat = catCount;
											res.data[i].cage_info[j].catCount = catCount;
										}else{
											dogCount = (dogCount + 1);
											res.data[i].dog = dogCount;
											res.data[i].cage_info[j].dogCount = dogCount;
										}
									}
								}
							}
						}
					}
				})
			},
			//接收按钮
			handleReceiveClick(){
				console.log('选择笼子',this.siteValue)
				if(this.chin_no == ''){
					this.$message({
						type: 'error',
						message: '请输入芯片编号'
					}); 
					return
				}
				if(this.siteValue.length == 0){
					this.$message({
						type: 'error',
						message: '请选择笼子'
					}); 
					return
				}
				let cageList = [];
				for(let i = 0;i<this.siteValue.length;i++){
					cageList.push({
						roomId:this.siteValue[i][0],
						cageId:this.siteValue[i][1]
					})
				}
				console.log('宠物笼子数据',cageList)
				let params = {
					id:this.receiveId,
					chipNo:this.chin_no,
					cageList:cageList
				}
				petsReceive(params).then((res)=>{
					if(res.code == 0){
						console.log(res)
						this.$message({
							type: 'success',
							message: '接收成功'
						}); 
						this.$emit("closeClick", false);
					}
				})
			},
			//获取开始时间和结束时间
			getStartEndData(nowDate) {
				// 获取时间
				let year = nowDate.getFullYear();
				let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1);
				let day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate();
				let startTime = `${year}-${month}-${day} 00:00:00`;
				let endTime = `${year}-${month}-${day} 23:59:59`;
				let startStr = new Date(startTime) / 1000;
				let endStr = new Date(endTime) / 1000;
				let formatDate = `${year}-${month}-${day}`;
				return {
					startStr: startStr,
					endStr: endStr,
					formatDate: formatDate
				}
			},
			//向父组件发射关闭弹框
			addCageClose(done) {
				done()
				this.$emit("closeOn", false);
			}
		},
		watch: {
			// 监视状态发生改变
			addCageState() {
				this.visible = this.addCageState;
			},
		}
	};
</script>
<style lang="scss" scoped>
	.shopView{
		display: flex;
		height: 300px;
		.roomView{
			width: 400px;
			height: 100%;
			border-right: solid 1px #D4D4D4;
			overflow-x: hidden;
			overflow-y: scroll;
			cursor: pointer;
			.roomName{
				font-size: 16px;
				color: #2A2A2A;
				margin-bottom: 10px;
				font-weight: bold;
				line-height: 24px;
			}
			.room{
				width: 90px;
				line-height: 30px;
				box-sizing: border-box;
				border: 1px solid #979797;
				border-radius: 2px;
				text-align: center;
				font-size: 14px;
				color: #3A3A3A;
				float: left;
				margin-right: 8px;
				margin-bottom: 20px;
			}
			.roomActive{
				width: 90px;
				line-height: 30px;
				box-sizing: border-box;
				border: 1px solid #979797;
				border-radius: 2px;
				text-align: center;
				font-size: 14px;
				color: #fff;
				float: left;
				margin-right: 8px;
				margin-bottom: 20px;
				background: #1890FF;
			}
		}
		.roomView::-webkit-scrollbar {
			display: none;
		}
		.cageView{
			flex: 1;
			overflow-x: hidden;
			overflow-y: scroll;
			.cage{
				overflow: hidden;
				
				.cageTitle{
					font-size: 14px;
					font-weight: bold;
					// margin-bottom: 10px;
					padding-left: 14px;
					line-height: 30px;
				}
				.cageItem{
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					width: 80px;
					height: 40px;
					box-sizing: border-box;
					position: relative;
					border: solid 1px #979797;
					border-radius: 4px;
					margin-left: 10px;
					margin-bottom: 14px;
					float: left;
					font-size: 14px;
					.petNum{
						font-size: 12px;
						margin-top: 4px;
					}
				}
			}
		}
		.cageView::-webkit-scrollbar {
			display: none;
		}
	}
</style>
